export default __webpack_public_path__ + "static/media/VT323-Regular.bddd705e.ttf";